<client-header
  [headerLabel]="'Features'"
  (click)="headerGroups.features = !headerGroups.features"
></client-header>

@if (headerGroups.features) {
  <div
    id="feature-collapse-container"
    class="collapse-container"
    >
    @if (!client.feed_enabled) {
      <div>
        <app-radio-btn
          [btnLabel]="'Go to Feed'"
          [btnWidth]="'460px'"
          [btnName]="'go-to-feed'"
          [(btnModel)]="productGroup.show_back_to_feed"
      [tiptext]="
        'Turning on this feature will enable customers to navigate back to their feed from the message details and message branch views.'
      "
          >
        </app-radio-btn>
      </div>
    }
    <div>
      <app-radio-btn
        [btnLabel]="client.feed_enabled ? 'Hide Feed Menu' : 'Hide Wire Menu'"
        [btnWidth]="'460px'"
        [btnName]="'hide-wire-menu'"
        [(btnModel)]="productGroup.hide_hamburger"
      [tiptext]="
        'Turning on this feature will hide the hamburger menu from the message details and client feed views.'
      "
        >
      </app-radio-btn>
    </div>
    @if (!client.feed_enabled) {
      <div>
        <app-radio-btn
          [btnLabel]="'Hide Product Group From Menu'"
          [btnWidth]="'460px'"
          [btnName]="'hide-product-group'"
          [(btnModel)]="productGroup.hide_pg_from_hamburger"
      [tiptext]="
        'Turning on this feature will hide the product group from the hamburger menu.'
      "
          >
        </app-radio-btn>
      </div>
    }
    <label class="inwire-consent"
      >In {{ client.feed_enabled ? 'Feed' : 'Wire' }} Consent</label
      >
      <app-radio-btn
        [btnLabel]="'Enable Action Element in Message Builder'"
        [btnWidth]="'460px'"
        [btnName]="'iwcu-message-builder'"
        [(btnModel)]="productGroup.consent.in_wire_upgrade.enabled"
        [labelIndentWidth]="15"
      ></app-radio-btn>
      @if (!client.feed_enabled) {
        <app-radio-btn
          [btnLabel]="'Password page'"
          [btnWidth]="'460px'"
          [btnName]="'iwcu-password-page'"
          [(btnModel)]="productGroup.consent.in_wire_upgrade.enabled_on_set_password"
          [disabled]="!productGroup.password.enabled"
    [tiptext]="
      !productGroup.password.enabled
        ? 'Password must be enabled to configure this feature.'
        : null
    "
          [labelIndentWidth]="15"
        ></app-radio-btn>
      }
    </div>
  }

  <client-header
    [headerLabel]="'Password'"
    (click)="headerGroups.password = !headerGroups.password"
  ></client-header>

  <div>
    @if (headerGroups.password) {
      <div
        id="password-collapse-container"
        class="collapse-container"
        >
        @if (!!productGroup.password) {
          <div>
            <app-radio-btn
              [btnLabel]="'Password Required'"
              [btnWidth]="'460px'"
              [btnName]="'password-required'"
              [(btnModel)]="productGroup.password.enabled"
              >
            </app-radio-btn>
            @if (this.client.feed_enabled && productGroup.password.enabled) {
              <p
                class="tip-text"
                >
                Please set content for the <strong>Password Creation</strong> page.
              </p>
            }
            <div class="pwd-req" [ngClass]="{ hide: !productGroup.password.enabled }">
              <div class="password-preview-config">
                @if (
                  client.feed_enabled) {
                  <rn-generic-phone size="large">
                    <set-password-page-preview-react
                      [pswMessageText]="productGroup.password.text"
                      [pswButtonLabel]="productGroup.password.label"
                      [pswTCS]="productGroup.password.tcs"
                      [pswTCMandatory]="productGroup.password.tc_mandatory"
                      [logoUrl]="productGroup.branding.icon_s3_url"
                      [color]="productGroup.branding.color"
                      [productGroupName]="productGroup.name"
                      [showProductGroup]="!productGroup.hide_pg_wire_display_name"
                      [productGroupDescription]="productGroup.description"
                      [showFdic]="productGroup.fdic.show_signage_on_authentication"
                      [fdic]="productGroup.fdic"
                      [showLogo]="productGroup.show_logo"
                      [showTitleBar]="productGroup.show_title_bar"
                [consentContent]="
                  productGroup.password.consent_upgrade_enabled &&
                  productGroup.consent.in_wire_upgrade.ts_cs
                "
                    ></set-password-page-preview-react>
                  </rn-generic-phone>
                } @else {
                  <rn-generic-phone>
                    <app-password-preview
                      [productGroup]="productGroup"
                      [client]="client"
                    ></app-password-preview>
                  </rn-generic-phone>
                }
                <div class="messaging-panel arrow-left-center">
                  <div class="card panel-default">
                    <div class="card-header">
                      <div class="col-sm-12">
                        Password
                        {{
                        this.client.feed_enabled
                        ? ' Creation Page Content'
                        : 'Required'
                        }}
                      </div>
                    </div>
                    <div class="card-body">
                      <form [formGroup]="passwordForm">
                        <div class="form-group">
                          <div>
                            <label>Password Creation Page Message</label>
                          </div>
                          <div style="display: flex">
                            <rn-form-input-state-control
                              [formReference]="passwordForm.controls['text']"
                              [isError]="passwordHasTextError()"
                              [showCharacterCount]="this.client.feed_enabled"
                              [totalLength]="getCharacterLimit('setPasswordText')"
                              >
                              <ng-container>
                                <app-tiny-editor
                                  class="tiny-editor-mentions"
                                  [elementId]="'tiny-editor-password-text'"
                                  [formControl]="passwordForm.controls['text']"
                                ></app-tiny-editor>
                              </ng-container>
                            </rn-form-input-state-control>
                          </div>
                        </div>
                        <div class="form-group">
                          <div>
                            <label>Submit button label</label>
                          </div>
                          <div style="display: flex">
                            <rn-form-input-state-control
                              [formReference]="passwordForm.controls['label']"
                              [showCharacterCount]="this.client.feed_enabled"
                        [totalLength]="
                          getCharacterLimit('setPasswordSubmitButtonLabel')
                        "
                              >
                              <ng-container>
                                <input
                                  name="button_label"
                                  class="form-control button_label"
                                  [(ngModel)]="setPasswordSubmitButtonDefaultText"
                                  [formControl]="passwordForm.controls['label']"
                                  />
                              </ng-container>
                            </rn-form-input-state-control>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
